export const QUERY_KEYS = {
  DASHBOARDS: (siteId: number) => ["site", siteId, "dashboards"],
  DASHBOARD_DATA: (
    siteId: number,
    dashboardId: number,
    startDate: string,
    endDate: string,
  ) => ["site", siteId, "dashboard", dashboardId, startDate, endDate],
  SITE_INTEGRATIONS: (siteId: number) => ["site", siteId, "integrations"],
  INTEGRATION_CONFIGURATION: (integrationId: number) => [
    "integration",
    integrationId,
    "configuration",
  ],
  USER_IDENTITIES: ["user-identities"],
};

export const DASHBOARD_NUM_COLUMNS = 6;
